import { Component, OnInit, HostBinding, EventEmitter, Output, Input, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, ElementRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { MessageNotice } from './message-notice';
import { BsModalService } from '@farris/ui-modal';
import { MessagerService } from '@farris/ui-messager';
import { MessageNoticeEditComponent } from './message-notice-edit/message-notice-edit.component';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { MessageNoticeCopyComponent } from './message-notice-copy/message-notice-copy.component';
import { ProcessDesignerViewModel } from '../../app/process-designer.viewmodel';
import { HttpService } from '@ecp-caf/caf-common';
import { MessageReceiver } from './message-receiver';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-message-notice',
  templateUrl: './message-notice.component.html',
  styleUrls: ['./message-notice.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class MessageNoticeComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(notices: any[]) {
    if (notices && notices.length > 0) {
      this.messageNotices = notices.map(n => ({
        id: ProcessDeUtil.GenerateElementId(),
        content: n.content,
        sendTime: n.sendTime,
        sendType: n.sendType,
        subject: n.subject,
        receiver: n.receiver,
        receiverText: n.receiverText,
        receivers: n.receivers ? n.receivers : new Array(),
        smsMessageTemplate: n.smsMessageTemplate
      }));
    }
  }
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  modalConfig = {
    title: this.localePipe.transform('component.MessageNotice.notify'),
    width: 760,
    height: 480,
    showButtons: true
  };

  messageNotices: Array<MessageNotice> = new Array();
  columns = [];

  location: 'activity' | 'process' | 'messageActivity' = 'activity';

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private message: MessagerService,
    private uistate: ProcessDesignerUIState,
    private viewModel: ProcessDesignerViewModel,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.GetOrganizationType();
  }

  ngOnInit() {
    this.location = this.editorParams.location;
    this.columns = [
      {
        field: 'subject', width: 100, title: this.localePipe.transform('component.MessageNotice.subject'),
      }, {
        field: 'content', width: 150, title: this.localePipe.transform('component.MessageNotice.content'), showTips: true,
      }, {
        field: 'sendTime', width: 100, title: this.localePipe.transform('component.MessageNotice.sendTime'),
        formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'text', data: this.location === 'process' ? this.processSendTime : this.activitySendTime }
        },
      }, {
        field: 'sendType', width: 100, title: this.localePipe.transform('component.MessageNotice.sendType'),
        formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'name', data: this.uistate.messageChannels.map(m => ({ value: m.code, name: m.name })) }
        },
      }, {
        field: 'receiverText', width: 120, title: this.localePipe.transform('component.MessageNotice.receiverText'), showTips: true, formatter: (v, d, i) => {
          let receiverText = '';
          if (d.receivers && d.receivers.length > 0) {
            for (const receiver of d.receivers) {
              if (receiver.type === 'processParticipant') {
                if (receiver.processParticipant === 'procInstCreator') {
                  receiverText += this.localePipe.transform('component.MessageNotice.procInstCreator');
                } else if (receiver.processParticipant === 'workItemParticipant') {
                  receiverText += this.localePipe.transform('component.MessageNotice.workItemParticipant');
                } else if (receiver.processParticipant === 'activityExecutorParticipant') {
                  receiverText += (receiver.activityDefName + '，');
                }
              } else if (receiver.type === 'userParticipant') {
                receiverText += (receiver.userNames + '，');
              } else if (receiver.type === 'variableParticipant') {
                receiverText += (receiver.variableName + '，');
              } else if (receiver.type === 'positionParticipant') {
                receiverText += (receiver.positionName + '，');
              }
            }
          }
          if (receiverText) {
            receiverText = receiverText.substring(0, receiverText.length - 1);
          }
          return receiverText;
        },
      }];
    if (this.location === 'messageActivity') {
      this.columns = this.columns.filter(c => c.field !== 'sendTime');
    }
  }

  add() {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(MessageNoticeEditComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.location = this.location;
    const messageNotice = new MessageNotice();
    if (this.location === 'activity') {
      messageNotice.sendTime = 'WORKITEM_CREATED';
      const messageReceiver = new MessageReceiver();
      messageReceiver.type = 'processParticipant';
      messageReceiver.processParticipant = 'workItemParticipant';
      messageNotice.receivers = [messageReceiver];
    } else if (this.location === 'process') {
      messageNotice.sendTime = 'PROCESSINSTANCE_COMPLETED';
      const messageReceiver = new MessageReceiver();
      messageReceiver.type = 'processParticipant';
      messageReceiver.processParticipant = 'procInstCreator';
      messageNotice.receivers = [messageReceiver];
    } else if (this.location === 'messageActivity') {
      const messageReceiver = new MessageReceiver();
      messageReceiver.type = 'processParticipant';
      messageReceiver.processParticipant = 'procInstCreator';
      messageNotice.receivers = [messageReceiver];
    }
    compRef.instance.value = messageNotice;
    compRef.instance.submitEmitter.subscribe((re: MessageNotice) => {
      this.messageNotices = this.messageNotices.concat([re]);
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe(re => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform('component.MessageNotice.messageSet'),
      width: 760,
      height: 480,
      showButtons: true,
      buttons: compRef.instance.footer
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }
  edit() {
    if (!this.grid.selectedRow) {
      this.message.info(this.localePipe.transform('component.MessageNotice.selectedRow'));
      return;
    }
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(MessageNoticeEditComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.location = this.location;
    compRef.instance.value = this.grid.selectedRow.data;
    compRef.instance.submitEmitter.subscribe((re: MessageNotice) => {
      this.messageNotices = this.messageNotices.map(m => {
        if (m.id === re.id) {
          return re;
        }
        return m;
      });
      this.grid.unSelectRow(this.grid.selectedRow.data.id, true);
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe(re => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform('component.MessageNotice.messageSet'),
      width: 760,
      height: 480,
      showButtons: true,
      buttons: compRef.instance.footer
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }
  batchCopy() {
    if (!this.messageNotices) {
      this.message.info(this.localePipe.transform('component.MessageNotice.noCopy'));
      return;
    }
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(MessageNoticeCopyComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.messageNotices = this.messageNotices;
    compRef.instance.submitEmitter.subscribe((data: any) => {
      this.viewModel.copy(ResourceKeys.batchCopyProperty, data);
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe(re => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform('component.MessageNotice.batchCopy'),
      width: 800,
      height: 515,
      showButtons: true,
      buttons: compRef.instance.modalFooter
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }
  delete() {
    const selected = this.grid.selectedRow;
    if (!selected) {
      this.message.info(this.localePipe.transform('component.MessageNotice.selectedRow'));
      return;
    }
    this.messageNotices = this.messageNotices.filter(m => m.id !== selected.id);
  }
  clickOK() {
    const object = { value: this.messageNotices, parameters: null };
    this.submitModal.emit(object);
  }
  clickCancel() {
    this.closeModal.emit();
  }

  private GetOrganizationType() {
    const url = '/api/runtime/sys/v1.0/authfields/globalauthfields';
    this.http.get(url)
      .subscribe((data: any) => this.uistate.orgTypeCollection = data.map(d => ({ value: d.id, text: d.name })));
  }

  processSendTime = [
    { value: 'PROCESSINSTANCE_COMPLETED', text: this.localePipe.transform('component.MessageNotice.procComplete') },
    { value: 'PROCESSINSTANCE_ABORTED', text: this.localePipe.transform('component.MessageNotice.procAborted') },
    { value: 'PROCESSINSTANCE_ROLLBACK', text: this.localePipe.transform('component.MessageNotice.procRollBack') }
  ];

  activitySendTime = [
    { value: 'WORKITEM_CREATED', text: this.localePipe.transform('component.MessageNotice.workCreated') },
    { value: 'WORKITEM_ABORTED', text: this.localePipe.transform('component.MessageNotice.workAborted') },
    { value: 'ACTIVITY_COMPLETED', text: this.localePipe.transform('component.MessageNotice.actComplete') },
    { value: 'ACTIVITY_ABORTED', text: this.localePipe.transform('component.MessageNotice.actAborted') },
  ];
}

export enum ResourceKeys {
  batchCopyProperty = 'batchCopyProperty'
}

export class MessageNoticeConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data.length > 0) {
      return this.localePipe.transform("component.MessageNotice.set");
    } else {
      return this.localePipe.transform("component.MessageNotice.notSet");
    }
  }
}
